import { useEffect } from "react";

interface JsonLdProps {
  /** Stable id so multiple JsonLd blocks coexist and can be replaced cleanly */
  id: string;
  data: Record<string, unknown> | Record<string, unknown>[];
}

const JsonLd = ({ id, data }: JsonLdProps) => {
  useEffect(() => {
    const elementId = `jsonld-${id}`;
    let script = document.getElementById(elementId) as HTMLScriptElement | null;
    const created = !script;
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = elementId;
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(data);

    return () => {
      // Defensive removal: only remove if still attached to its parent.
      // Avoids "removeChild ... is not a child of this node" during
      // route transitions / StrictMode double-invocation.
      if (created) {
        const existing = document.getElementById(elementId);
        if (existing && existing.parentNode) {
          existing.parentNode.removeChild(existing);
        }
      }
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
